export default __webpack_public_path__ + "b8c6b62d4f57bccbdb25ead95d8ea811.ttf";